(function () {
  var KEY = 'tcl_compare_handles';
  var TRAY_COLLAPSED_KEY = 'tcl_compare_tray_collapsed';
  var MAX = 4;
  var toastTimer = null;

  function toast(message) {
    var el = document.querySelector('[data-compare-toast]');
    if (!el) {
      el = document.createElement('div');
      el.className = 'compare-toast';
      el.setAttribute('data-compare-toast', '');
      document.body.appendChild(el);
    }
    el.textContent = message;
    el.classList.add('is-showing');
    if (toastTimer) window.clearTimeout(toastTimer);
    toastTimer = window.setTimeout(function () {
      el.classList.remove('is-showing');
    }, 2000);
  }

  function read() {
    try {
      var raw = localStorage.getItem(KEY);
      var arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr.filter(Boolean) : [];
    } catch (e) {
      return [];
    }
  }

  function write(arr) {
    localStorage.setItem(KEY, JSON.stringify(arr));
    window.dispatchEvent(new CustomEvent('compare:change', { detail: { handles: arr } }));
  }

  function unique(arr) {
    return Array.from(new Set(arr));
  }

  function add(handle) {
    var arr = unique(read());
    if (arr.includes(handle)) return { ok: true, handles: arr };
    if (arr.length >= MAX) return { ok: false, reason: 'max', handles: arr };
    arr.push(handle);
    write(arr);
    return { ok: true, handles: arr };
  }

  function remove(handle) {
    var arr = read().filter(function (h) {
      return h !== handle;
    });
    write(arr);
    return { ok: true, handles: arr };
  }

  function clearAll() {
    write([]);
  }

  function buildCompareUrl(handles) {
    var qs = new URLSearchParams();
    qs.set('handles', handles.join(','));
    return '/pages/compare?' + qs.toString();
  }

  function getProductData(handle) {
    var node = document.querySelector('[data-compare-product-json][data-handle="' + handle + '"]');
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (e) {
      return null;
    }
  }

  function modalEls() {
    var modal = document.querySelector('[data-compare-modal]');
    if (!modal) return null;
    return {
      modal: modal,
      content: modal.querySelector('[data-compare-modal-content]')
    };
  }

  function modalContentEls() {
    var nodes = [];
    document.querySelectorAll('[data-compare-modal-content]').forEach(function (el) {
      if (nodes.indexOf(el) === -1) nodes.push(el);
    });
    var popupContent = document.getElementById('CompareModalContent');
    if (popupContent && nodes.indexOf(popupContent) === -1) nodes.push(popupContent);
    return nodes;
  }

  function closeModal() {
    var els = modalEls();
    if (!els) return;
    els.modal.classList.remove('is-open');
    els.modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('compare-modal-open');
  }

  function renderModal(handles) {
    var contentEls = modalContentEls();
    if (!contentEls.length) return;

    var products = handles.slice(0, MAX).map(getProductData).filter(Boolean);
    if (products.length < 2) {
      contentEls.forEach(function (el) {
        el.innerHTML = '<p>Please select at least 2 products to compare.</p>';
      });
      return;
    }

    var rows = [
      { key: 'size', label: 'Size' },
      { key: 'local_dimming_zones', label: 'Local Dimming Zones' },
      { key: 'brightness', label: 'Brightness' },
      { key: 'screen', label: 'Screen' },
      { key: 'audio', label: 'Audio' },
      { key: 'design', label: 'Design' },
      { key: 'tv_os', label: 'TV OS' }
    ];

    var thead =
      '<thead><tr>' +
      '<th class="compare-modal__spec">Spec</th>' +
      products
        .map(function (p) {
          var listTitle = Array.isArray(p.list_title) ? p.list_title : [];
          var mainTitle = listTitle[0] ? String(listTitle[0]) : '';
          var subTitle = listTitle[1] ? String(listTitle[1]) : '';
          var styleProducts = Array.isArray(p.style_products) ? p.style_products : [];
          var styleHtml = '';

          if (styleProducts.length) {
            styleHtml =
              '<div class="style_product_box">' +
              '<div class="other-style">' +
              '<div class="style-options">' +
              styleProducts
                .map(function (sp) {
                  var isCurrent = sp && sp.handle === p.handle;
                  var styleTitle = sp && sp.style_title ? String(sp.style_title) : '';
                  return (
                    '<a href="' +
                    escapeHtml((sp && sp.url) || '#') +
                    '" class="style-link' +
                    (isCurrent ? ' current' : '') +
                    '">' +
                    '<div class="style-options_title">' +
                    '<p>' +
                    escapeHtml(styleTitle) +
                    '</p>' +
                    '</div>' +
                    '</a>'
                  );
                })
                .join('') +
              '</div>' +
              '</div>' +
              '</div>';
          }

          var titleHtml =
            '<div class="compare-modal__prodTitle card_product_title_box">' +
            (mainTitle
              ? '<h3 class="card_product_title h4">' + escapeHtml(subTitle) + '</h3>'
              : '<h3 class="card_product_title h4">' + escapeHtml(p.title || p.handle) + '</h3>') +
            (subTitle ? '<span class="card_product_list_title">' + escapeHtml(mainTitle) + '</span>' : '') +
            styleHtml +
            '</div>';

          return (
            '<th>' +
            (p.image ? '<img class="compare-modal__prodImg" src="' + p.image + '" alt=""/>' : '') +
            titleHtml +
            '<div class="compare-modal__prodPrice">' +
            escapeHtml(p.price || '') +
            '</div>' +
            '<a class="button button--secondary" href="' +
            (p.url || '#') +
            '">View</a>' +
            '</th>'
          );
        })
        .join('') +
      '</tr></thead>';

    var tbody =
      '<tbody>' +
      rows
        .map(function (r) {
          return (
            '<tr>' +
            '<td class="compare-modal__spec">' +
            escapeHtml(r.label) +
            '</td>' +
            products
              .map(function (p) {
                var v = p.specs && p.specs[r.key] ? String(p.specs[r.key]) : '—';
                return '<td>' + escapeHtml(v) + '</td>';
              })
              .join('') +
            '</tr>'
          );
        })
        .join('') +
      '</tbody>';

    var html = '<table class="compare-modal__table">' + thead + tbody + '</table>';
    contentEls.forEach(function (el) {
      el.innerHTML = html;
    });
  }

  function escapeHtml(s) {
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function openModal(handles) {
    renderModal(handles);
    var els = modalEls();
    if (!els) return;
    els.modal.classList.add('is-open');
    els.modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('compare-modal-open');
  }

  function setToggleState(btn, active) {
    btn.classList.toggle('is-active', !!active);
    btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    var on = btn.getAttribute('data-on-label') || 'Remove';
    var off = btn.getAttribute('data-off-label') || 'Compare';
    var textEl = btn.querySelector('.compare-toggle__text');
    if (textEl) {
      textEl.textContent = active ? on : off;
    } else {
      btn.textContent = active ? on : off;
    }
  }

  function syncToggles(handles) {
    document.querySelectorAll('[data-compare-toggle]').forEach(function (btn) {
      var handle = btn.getAttribute('data-handle');
      if (!handle) return;
      setToggleState(btn, handles.includes(handle));
    });
  }

  function trayEl() {
    return document.querySelector('[data-compare-tray]');
  }

  function readTrayCollapsed() {
    try {
      return localStorage.getItem(TRAY_COLLAPSED_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function writeTrayCollapsed(collapsed) {
    try {
      localStorage.setItem(TRAY_COLLAPSED_KEY, collapsed ? '1' : '0');
    } catch (e) {}
  }

  function applyTrayCollapsedState(tray, collapsed) {
    if (!tray) return;
    var wrap = tray.querySelector('[data-compare-chips-wrap]');
    if (wrap) {
      wrap.classList.toggle('is-collapsed', !!collapsed);
    } else {
      tray.classList.toggle('is-collapsed', !!collapsed);
    }
    var toggle = tray.querySelector('[data-compare-chips-toggle]');
    if (!toggle) return;
    var label = toggle.querySelector('.c-compare-toggle__label');
    toggle.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
    toggle.setAttribute('aria-label', collapsed ? 'Expand compare products' : 'Collapse compare products');
    if (label) label.textContent = collapsed ? 'Expand' : 'Collapse';
  }

  function bindTrayToggle(tray, hasItems) {
    if (!tray) return;
    var toggle = tray.querySelector('[data-compare-chips-toggle]');
    if (!toggle) return;

    toggle.hidden = !hasItems;
    if (!hasItems) {
      applyTrayCollapsedState(tray, false);
      return;
    }

    if (!toggle._compareToggleBound) {
      toggle._compareToggleBound = true;
      toggle.addEventListener('click', function () {
        var wrap = tray.querySelector('[data-compare-chips-wrap]');
        var isCollapsed = wrap ? wrap.classList.contains('is-collapsed') : tray.classList.contains('is-collapsed');
        var next = !isCollapsed;
        applyTrayCollapsedState(tray, next);
        writeTrayCollapsed(next);
      });
    }

    var chipsWrap = tray.querySelector('[data-compare-chips-wrap]');
    if (chipsWrap && !chipsWrap._compareWrapBound) {
      chipsWrap._compareWrapBound = true;
      chipsWrap.addEventListener('click', function (e) {
        if (e.target.closest('[data-compare-chips-toggle], .compare-chip a, .compare-chip button')) return;
        var isCollapsed = chipsWrap.classList.contains('is-collapsed');
        var next = !isCollapsed;
        applyTrayCollapsedState(tray, next);
        writeTrayCollapsed(next);
      });
    }

    applyTrayCollapsedState(tray, readTrayCollapsed());
  }

  function getTitleCacheKey(handle) {
    return 'tcl_compare_title:' + handle;
  }

  function getCachedTitle(handle) {
    try {
      return sessionStorage.getItem(getTitleCacheKey(handle)) || '';
    } catch (e) {
      return '';
    }
  }

  function setCachedTitle(handle, title) {
    try {
      sessionStorage.setItem(getTitleCacheKey(handle), title);
    } catch (e) {}
  }

  function fetchProductTitle(handle) {
    return fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('bad_status');
        return r.json();
      })
      .then(function (p) {
        var title = (p && p.title) ? String(p.title) : '';
        if (title) setCachedTitle(handle, title);
        return title;
      })
      .catch(function () {
        return '';
      });
  }

  function syncTray(handles) {
    var tray = trayEl();
    if (!tray) return;

    tray.classList.toggle('is-open', handles.length > 0);

    var count = tray.querySelector('[data-compare-count]');
    if (count) count.textContent = handles.length + ' / ' + MAX;

    var chips = tray.querySelector('[data-compare-chips]');
    if (chips) {
      chips.innerHTML = '';

      handles.forEach(function (h) {
        var cached = getCachedTitle(h);
        var product = getProductData(h) || {};
        var displayTitle = (product.title && String(product.title)) || cached || h;

        var chip = document.createElement('article');
        chip.className = 'compare-chip';
        chip.innerHTML =
          '<button type="button" class="compare-chip__remove" aria-label="Remove">×</button>' +
          '<a class="compare-chip__main" href="' + escapeHtml(product.url || '#') + '">' +
          '<span class="compare-chip__thumb">' +
          (product.image ? '<img src="' + escapeHtml(product.image) + '" alt="" loading="lazy"/>' : '') +
          '</span>' +
          '<span class="compare-chip__title compare-chip__title_new" data-compare-chip-title>' +
          escapeHtml(displayTitle) +
          '</span>' +
          (function () {
            var lt = product.list_title;
            var t0 = (lt && lt[0]) ? String(lt[0]) : '';
            var t1 = (lt && lt[1]) ? String(lt[1]) : '';
            if (!t0 && !t1) return '';
            return '<div class="card_product_title_box">' +
              (t0 ? '<h3 class="card_product_title h4">' + escapeHtml(t1) + '</h3>' : '') +
              (t1 ? '<span class="card_product_list_title">' + escapeHtml(t0) + '</span>' : '') +
              '</div>';
          })() +
          '</a>';
        chip.querySelector('button').addEventListener('click', function () {
          remove(h);
        });
        chips.appendChild(chip);

        if (!product.title && !cached) {
          fetchProductTitle(h).then(function (title) {
            if (!title) return;
            var el = chip.querySelector('[data-compare-chip-title]');
            if (el) el.textContent = title;
          });
        }
      });

      for (var i = handles.length; i < MAX; i++) {
        var empty = document.createElement('div');
        empty.className = 'compare-chip compare-chip--empty';
        empty.innerHTML =
          '<span class="compare-chip__thumb_new"></span>' +
          '<span class="compare-chip__title">Add product</span>';
        chips.appendChild(empty);
      }
    }

    bindTrayToggle(tray, handles.length > 0);

    var btn = tray.querySelector('[data-compare-go]');
    if (btn) {
      btn.disabled = handles.length < 2;
      btn.onclick = function () {
        openModal(handles);
      };
    }

    var clear = tray.querySelector('[data-compare-clear]');
    if (clear) {
      clear.disabled = handles.length === 0;
      clear.onclick = clearAll;
    }
  }

  function onChange() {
    var handles = read();
    syncToggles(handles);
    syncTray(handles);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-compare-toggle]');
    if (!btn) return;

    var handle = btn.getAttribute('data-handle');
    if (!handle) return;

    var handles = read();
    var active = handles.includes(handle);

    if (active) {
      remove(handle);
      return;
    }

    var res = add(handle);
    if (!res.ok && res.reason === 'max') {
      toast('You can compare up to ' + MAX + ' products.');
    }
  });

  window.addEventListener('compare:change', onChange);
  window.addEventListener('storage', function (e) {
    if (e.key === KEY) onChange();
  });

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-compare-modal-close]')) {
      closeModal();
      return;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeModal();
  });

  onChange();
})();
